<template>
  <div style="width:100%">
    <el-alert title="提示:输入单位名称,选择RAC文件,点击确定,生成RAU文件,点击下载." type="warning" show-icon center></el-alert>
    <el-input placeholder="请输入内容" v-model="danwei">
      <template slot="prepend">单位名称</template>
    </el-input>
    <div class="box">
      <input
        type="file"
        name="file-1[]"
        id="file-1"
        @input="inputfunc"
        class="inputfile inputfile-1"
        data-multiple-caption="{count} files selected"
        multiple
      />
      <label for="file-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
          <path
            d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
          />
        </svg>
        <span>选择Rac文件&hellip;</span>
      </label>
    </div>
    <el-button
      type="danger"
      @click="jiesuo"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-text="执行中，请稍后..."
    >确定</el-button>
    <el-button
      type="success"
      v-if="play"
      style="width:200px ;height:48px;margin-top:20px ;font-size:1.20rem;font-weight: 600;"
      icon="el-icon-download"
    >
      <a href="#" id="rauget" style="text-decoration:none;color: #f1e5e6;font-weight:700;">下载Rau文件</a>
    </el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fullLoading: false,
      play: false,
      danwei: "",
    };
  },
  methods: {
    jiesuo() {
      if (this.danwei.length <= 0) {
        return this.$message({
          showClose: true,
          message: "请输入单位名称",
          type: "error",
        });
      }
      var fileInput = document.getElementById("file-1");
      if (fileInput.files.length <= 0) {
        return this.$message({
          showClose: true,
          message: "请选择RAC文件",
          type: "error",
        });
      }
      let formData = new FormData();
      formData.append("companyName", this.danwei);
      formData.append("racFile", fileInput.files[0], fileInput.files[0].name);
      this.$http
        .post(this.$getaxiosurl("/enc/unlock/lgao"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.play = true;
            this.fullLoading = false;
            setTimeout(() => {
              let rau = document.getElementById("rauget");
              rau.href = response.data.rauFile;
              this.$message({
                message: "成功",
                type: "success",
              });
            }, 0);
          } else {
            this.fullLoading = false;
            this.$message({
              showClose: true,
              message: response.data.msg,
              type: "error",
            });
          }
        });
    },
    inputfunc() {
      var inputs = document.querySelectorAll(".inputfile");
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;
        input.addEventListener("change", function (e) {
          var fileName = "";
          if (this.files && this.files.length > 1)
            fileName = (
              this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
          else fileName = e.target.value.split("\\").pop();
          if (fileName) label.querySelector("span").innerHTML = fileName;
          else label.innerHTML = labelVal;
        });
      });
    },
  },
};
</script>
<style scoped>
.box {
  width: 280px;
}
.grid-a-content-a-Width {
  border-radius: 4px;
  width: 100%;
}
.el-checkbox {
  color: #000000;
  margin: 40px;
}
h3 {
  text-align: center;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.js .inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.inputfile + label {
  max-width: 80%;
  font-size: 1.25rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.625rem 1.25rem;
}
.no-js .inputfile + label {
  display: none;
}
.inputfile:focus + label,
.inputfile.has-focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}
.inputfile + label svg {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  margin-right: 0.25em;
}
.inputfile-1 + label {
  color: #f1e5e6;
  background-color: #409eff;
}
.inputfile-1:focus + label,
.inputfile-1.has-focus + label,
.inputfile-1 + label:hover {
  background-color: #67c23a;
}
</style>
